import { useState } from 'react';
interface DimensionInfo { name: string; size: number; }

export function defaultFixedAxes(shape: number[]) {
  return shape.map((_, i) => i).slice(1);
}


export function useExploration(object: string, shape: number[]) {
  const key = `${object}/${shape.join(',')}`;
  const [slice, setSlice] = useState<{ key: string; fixed: number[]; values: Record<number, number> }>({ key: '', fixed: [], values: {} });
  const fixed = slice.key === key ? slice.fixed : defaultFixedAxes(shape);
  const values = slice.key === key ? slice.values : {};
  if (slice.key !== key) setSlice({ key, fixed, values });
  return { fixed, values,
    onView: (next: number[]) => setSlice({ key, fixed: next, values }),
    onValue: (axis: number, value: number) => setSlice({ key, fixed, values: { ...values, [axis]: value } }),
  };
}

export default function ExploreControls({ dimensions, fixed, values, labels, onView, onValue }: {
  dimensions: DimensionInfo[]; fixed: number[]; values: Record<number, number>; labels: string[][];
  onView: (fixed: number[]) => void; onValue: (axis: number, value: number) => void;
}) {
  if (!dimensions.length) return null;
  const indices = dimensions.map((_, i) => i);
  const free = indices.filter(i => !fixed.includes(i));
  const plural = (name: string) => name.toLowerCase().replace(/country$/, 'countries').replace(/sector$/, 'sectors').replace(/importer$/, 'importers').replace(/exporter$/, 'exporters');
  const views = indices.map(i => ({ value: String(i), label: `Compare ${plural(dimensions[i].name)}` }));
  for (let a = 0; a < dimensions.length; a++) {
    for (let b = a + 1; b < dimensions.length; b++) {
      views.push({ value: `${a},${b}`, label: dimensions.length === 2 ? 'Full matrix' : `${dimensions[a].name} × ${dimensions[b].name}` });
    }
  }
  views.push({ value: '', label: 'Single value' });
  return <div className="explore-controls">
    <label>Explore<select aria-label="Explore view" value={free.join(',')} onChange={event => {
      const next = event.target.value === '' ? [] : event.target.value.split(',').map(Number);
      onView(indices.filter(i => !next.includes(i)));
    }}>{views.map(view => <option key={view.value} value={view.value}>{view.label}</option>)}</select></label>
    {fixed.map(i => <label key={i}>{dimensions[i].name}<select aria-label={`Selected ${dimensions[i].name}`} value={values[i] || 0}
      onChange={event => onValue(i, Number(event.target.value))}>
      {labels[i].map((label, j) => <option key={j} value={j}>{label}</option>)}
    </select></label>)}
  </div>;
}
